module.exports = __webpack_public_path__ + "static/media/YF19_0.590efc8b.jpg";